"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshTokenExpirationPayload = exports.CustomUserDataConfig = void 0;
var json2typescript_1 = require("json2typescript");
var CustomUserDataConfig = (function () {
    function CustomUserDataConfig(partial) {
        this.mongoServiceId = '';
        this.databaseName = '';
        this.collectionName = '';
        this.userIdField = '';
        this.enabled = false;
        this.onUserCreationFunctionId = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('mongo_service_id'),
        __metadata("design:type", Object)
    ], CustomUserDataConfig.prototype, "mongoServiceId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('database_name'),
        __metadata("design:type", Object)
    ], CustomUserDataConfig.prototype, "databaseName", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('collection_name'),
        __metadata("design:type", Object)
    ], CustomUserDataConfig.prototype, "collectionName", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('user_id_field'),
        __metadata("design:type", Object)
    ], CustomUserDataConfig.prototype, "userIdField", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('enabled'),
        __metadata("design:type", Object)
    ], CustomUserDataConfig.prototype, "enabled", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('on_user_creation_function_id', String, true),
        __metadata("design:type", String)
    ], CustomUserDataConfig.prototype, "onUserCreationFunctionId", void 0);
    CustomUserDataConfig = __decorate([
        (0, json2typescript_1.JsonObject)('CustomUserDataConfig'),
        __metadata("design:paramtypes", [Object])
    ], CustomUserDataConfig);
    return CustomUserDataConfig;
}());
exports.CustomUserDataConfig = CustomUserDataConfig;
var RefreshTokenExpirationPayload = (function () {
    function RefreshTokenExpirationPayload(partial) {
        this.expirationTimeSeconds = 5184000;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('expiration_time_seconds'),
        __metadata("design:type", Object)
    ], RefreshTokenExpirationPayload.prototype, "expirationTimeSeconds", void 0);
    RefreshTokenExpirationPayload = __decorate([
        (0, json2typescript_1.JsonObject)('RefreshTokenExpiration'),
        __metadata("design:paramtypes", [Object])
    ], RefreshTokenExpirationPayload);
    return RefreshTokenExpirationPayload;
}());
exports.RefreshTokenExpirationPayload = RefreshTokenExpirationPayload;
//# sourceMappingURL=UserSettings.js.map